import React, { PureComponent } from 'react'
import { bool, shape, number, object, array, string } from 'prop-types'
import { createComponent } from '@ycos/fela'
import { getImageTypes } from './utils'
import BasePicture from './BasePicture'
import LazyLoadedPicture from './LazyLoadedPicture'

export const Placeholder = createComponent(
  'Placeholder',
  ({ desktop, mobile, forceAspectRatioMobile, forceAspectRatioDesktop }) => ({
    background: '#eee',
    position: 'relative',
    paddingBottom: `${(forceAspectRatioMobile || mobile.height / mobile.width) * 100}%`,
    height: '100%',
    'screen-medium': {
      paddingBottom: `${(forceAspectRatioDesktop || desktop.height / desktop.width) * 100}%`
    }
  }),
  'div'
)

export const StickyPlaceholder = createComponent(
  'StickyPlaceholder',
  ({ desktop }) => ({
    background: 'white',
    position: 'relative',
    paddingBottom: `calc(${(desktop.height / desktop.width) * 100}% - 102px)`,
    overflow: 'hidden',
    'screen-medium-max': {
      paddingBottom: 'calc(133.3333vw - 120px)'
    }
  }),
  'div'
)

class Picture extends PureComponent {
  render() {
    const {
      imagesphere: { quality, nonTransformableUrls, wZero },
      images = [],
      style,
      lazy,
      stickyText,
      widths,
      intersectionObserverOptions,
      forceAspectRatioMobile,
      forceAspectRatioDesktop,
      fetchPriority,
      position,
      extension
    } = this.props

    const devicePicture = getImageTypes({ pictures: images }, ['Desktop', 'Mobile', 'Overlay'])
    const mobilePicture = devicePicture.Mobile
    const desktopPicture = devicePicture.Desktop
    const PlaceholderType = stickyText ? StickyPlaceholder : Placeholder

    return (
      <PlaceholderType
        forceAspectRatioMobile={forceAspectRatioMobile}
        forceAspectRatioDesktop={forceAspectRatioDesktop}
        desktop={desktopPicture}
        mobile={mobilePicture}
        data-automation="picture"
      >
        <LazyLoadedPicture lazy={lazy} position={position} intersectionObserverOptions={intersectionObserverOptions}>
          <BasePicture
            fetchPriority={fetchPriority}
            desktopPicture={desktopPicture}
            lazy={lazy}
            mobilePicture={mobilePicture}
            quality={quality}
            widths={widths}
            nonTransformableUrls={nonTransformableUrls}
            wZero={wZero}
            imageStyle={style}
            stickyText={stickyText}
            extension={extension}
          />
        </LazyLoadedPicture>
        <noscript>
          <LazyLoadedPicture lazy={false} position={position}>
            <BasePicture
              desktopPicture={desktopPicture}
              lazy={false}
              mobilePicture={mobilePicture}
              quality={quality}
              widths={widths}
              nonTransformableUrls={nonTransformableUrls}
              wZero={wZero}
              imageStyle={style}
              stickyText={stickyText}
              extension={extension}
            />
          </LazyLoadedPicture>
        </noscript>
      </PlaceholderType>
    )
  }
}

export default Picture

Picture.propTypes = {
  lazy: bool,
  imagesphere: shape({
    quality: number,
    nonTransformableUrls: array,
    wZero: bool
  }),
  intersectionObserverOptions: object,
  forceAspectRatioMobile: number,
  forceAspectRatioDesktop: number,
  fetchPriority: string,
  extension: string
}

// 65 as default quality
Picture.defaultProps = {
  lazy: false,
  imagesphere: {
    quality: 65,
    nonTransformableUrls: [],
    wZero: false
  },
  fetchPriority: null
}
